import { chainRegistry } from '../chains/registry';
import { createEvmAdapter } from '../adapters/evmAdapter';
import { createSolanaAdapter } from '../adapters/solanaAdapter';

const adapters = Object.fromEntries(
  Object.values(chainRegistry).map(chain => [
    chain.key,
    chain.adapter === 'solana' ? createSolanaAdapter(chain) : createEvmAdapter(chain),
  ])
);

export const getSwapAdapter = chainKey => adapters[chainKey];

export const getCapabilities = chainKey => adapters[chainKey].getCapabilities();

export const fetchBalances = async ({ chainKey, walletContext, inputAsset }) =>
  adapters[chainKey].getBalances({
    provider: walletContext?.provider,
    account: walletContext?.address,
    inputAsset,
  });

export const checkAllowance = async ({ chainKey, walletContext, inputAsset, amount }) =>
  adapters[chainKey].checkAllowanceLikeCapability({
    provider: walletContext?.provider,
    account: walletContext?.address,
    inputAsset,
    amount,
  });

export const approveIfRequired = async ({ chainKey, walletContext, inputAsset, amount }) =>
  adapters[chainKey].approveIfRequired({
    provider: walletContext?.provider,
    account: walletContext?.address,
    inputAsset,
    amount,
  });

export const simulateSwap = async ({ chainKey, walletContext, inputAsset, amount }) =>
  adapters[chainKey].simulateSwap({
    provider: walletContext?.provider,
    account: walletContext?.address,
    inputAsset,
    amount,
  });

export const submitSwap = async ({ chainKey, walletContext, inputAsset, amount, onSubmitted }) =>
  adapters[chainKey].submitSwap({
    provider: walletContext?.provider,
    wallet: walletContext?.solanaWallet,
    account: walletContext?.address,
    inputAsset,
    amount,
    onSubmitted,
  });
